import { GetState, SetState } from 'zustand';
import { IBillsHubSlice } from './index';
import {
  isBillStatusAwaitingDetails, isBillStatusPaid, isBillStatusPending, removeBillByBillId,
} from '../utils';
import { IFlattenServerErrorResponse, IServerErrorResponse } from '../../../../../types';
import { flattenServerErrorResponse } from '../../../../../helpers/errors.helper';

export interface IBillUtilsSlice {
  removeBillFromList: (billStatus: string, billId: string) => void;
  billError: IFlattenServerErrorResponse | null;
  setBillError: (error: IServerErrorResponse) => void;
  resetError: () => void;
  resetBillUtilsSlice: () => void;
}

const billUtilsSliceInitialState = {
  billError: null,
};

const createBillUtilsSlice = (set: SetState<IBillsHubSlice>, get: GetState<IBillsHubSlice>) => ({
  removeBillFromList: (billStatus: string, billId: string) => {
    if (isBillStatusPaid(billStatus)) {
      set({ totalPaidBills: get().totalPaidBills - 1 });
      set({ paidBills: removeBillByBillId(get().paidBills, billId) });
    }
    if (isBillStatusPending(billStatus) || isBillStatusAwaitingDetails(billStatus)) {
      set({ totalUnPaidBills: get().totalUnPaidBills - 1 });
      set({ unpaidBills: removeBillByBillId(get().unpaidBills, billId) });
    }
  },
  billError: null,
  setBillError: (error: IServerErrorResponse) => {
    set({ billError: flattenServerErrorResponse(error) });
  },
  resetError: () => set({ billError: null }),
  resetBillUtilsSlice: () => {
    set(billUtilsSliceInitialState);
  },
});

export default createBillUtilsSlice;
